var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoyalityMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1363 24.2482L23.2363 23.1252C23.3728 21.6226 22.3722 20.2525 20.8993 19.9252L17.4283 19.1142V13.3732C17.4179 12.8675 17.2062 12.3868 16.8401 12.0377C16.4741 11.6886 15.984 11.4998 15.4783 11.5132C14.9843 11.4927 14.5051 11.6842 14.1612 12.0396C13.8174 12.3949 13.6417 12.8801 13.6783 13.3732V22.5732L12.2003 21.4702C11.5901 21.0145 10.7379 21.0758 10.1993 21.6142C9.66063 22.1526 9.5989 23.0048 10.0543 23.6152L10.5293 24.2482",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99979 18.2492C4.73993 18.2478 1.18152 15.0035 0.787706 10.7619C0.393887 6.52024 3.29417 2.67622 7.48096 1.89065C11.6678 1.10507 15.7642 3.63628 16.9348 7.73215",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3569 6.46316H8.04792C7.66656 6.4326 7.291 6.57092 7.02057 6.84154C6.75015 7.11216 6.61209 7.48782 6.64292 7.86916C6.64292 9.40916 11.3569 10.5882 11.3569 12.1292C11.3624 12.5021 11.2166 12.8614 10.9529 13.1251C10.6891 13.3889 10.3299 13.5346 9.95692 13.5292H6.64292",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.46331V4.69531",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.3012V13.5332",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyalityMenuIcon);
export default __webpack_public_path__ + "static/media/royality-menu-icon.16a28fc45ad31f62daaf0980eb653c15.svg";
export { ForwardRef as ReactComponent };